<template>
  <div class="container">
    <TitleHeader>RAG Rule Manager |
      <span class="text-color-darkgrey">{{ page }}</span></TitleHeader>
    <div class="row">
      <div class="col-3">
        <SubMenu>
          <SubMenuLink
              link-name="Create rule"
              :icon-src="list"
              :page="page"
              @navigate="handleNavigate"
          />
          <SubMenuLink
              link-name="View rules"
              :icon-src="clock"
              :page="page"
              @navigate="handleNavigate"
          />
        </SubMenu>
      </div>
      <div class="col-9">
        <div class="card mb-4">
          <div class="card-body text-left">
            <RagRuleForm v-if="page === 'Create rule'" />
            <RagRuleView v-if="page === 'View rules'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SubMenu from "@/components/menu/SubMenu";
import SubMenuLink from "@/components/menu/SubMenuLink";
import RagRuleForm from "@/components/form/RagRuleForm";
import RagRuleView from "@/components/rag-rule-manager/RagRuleView";
import list from "@fa/regular/list-alt.svg";
import clock from "@fa/regular/clock.svg";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "RuleManager",
  components: {
    SubMenu,
    SubMenuLink,
    RagRuleForm,
    RagRuleView
  },
  data: () => ({
    page: "Create rule",
    list,
    clock
  }),
  methods: {
    ...mapActions(['fetchProviderList']),
    ...mapMutations(['setLoading']),
    handleNavigate(page) {
      this.page = page;
    }
  },
  async beforeMount() {
    this.setLoading({ bool: true });
    await this.fetchProviderList().catch(err => console.log(err));
    this.setLoading({ bool: false });
  }
};
</script>
<style lang="scss"></style>